import React from "react";
import Typography from "@material-ui/core/Typography";
const User = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        User
      </Typography>
      <Typography paragraph variant="h5">
        Manage user master data and assign the authorization
      </Typography>
      <Typography paragraph variant="body1">
        User is one of the features under the User module to manage the user
        master data who have access to the platform. It contains any information
        regarding the user credential, user group assignment, and user
        authorization assignment. If both User Group and Authorization have been
        assigned to the user, it will prioritize Authorization value as the user
        authorization. The second prioritization is the Authorization value
        attached to the User Group.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the User list. It is
        displayed like a table that contains download functions, sort, filter,
        and global search on the header area, and contains data navigation and
        refresh function on the footer area. The data column that appears in
        this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>User ID</b>
        <br />
        Indicates the ID of the User.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Full Name</b>
        <br />
        Indicates the full name of the User.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Username</b>
        <br />
        Indicates the username of the User.
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Group</b>
        <br />
        Indicates the user group assignment of the User.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Authorization</b>
        <br />
        Indicates the authorization assignment of the User.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of User data with
        specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Generate & Send Core Platform Access Via Email</b>
        <br />
        This button is used to generate a new Core Platform access to the user
        email. In case you want to generate the password manually, please use
        the Edit User button instead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit User</b>
        <br />
        This button is used to edit the User data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete User</b>
        <br />
        This button is used to delete the User data. Any records that have the
        'Standard record protection' icon are unable to be deleted.
      </Typography>
    </React.Fragment>
  );
};

export default User;
